var _rect, _path, _path2, _g, _path3, _path4, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrl = function SvgBrl(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5513_107663",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 16,
    height: 12,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5513_107663)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2V14H16V2H0Z",
    fill: "#009933"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5513_107663",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2V14H16V2H0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5513_107663)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5513_107663)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96339 3.85202L14.0643 8.10375L7.8804 12.0856L1.90446 8.02134L7.96339 3.85202Z",
    fill: "#FFD221"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96339 3.85202L14.0643 8.10375L7.8804 12.0856L1.90446 8.02134L7.96339 3.85202Z",
    fill: "url(#paint0_linear_5513_107663)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.6C9.38071 10.6 10.5 9.48072 10.5 8.10001C10.5 6.71929 9.38071 5.60001 8 5.60001C6.61929 5.60001 5.5 6.71929 5.5 8.10001C5.5 9.48072 6.61929 10.6 8 10.6Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5513_107663",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 6,
    height: 6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.6C9.38071 10.6 10.5 9.48072 10.5 8.10001C10.5 6.71929 9.38071 5.60001 8 5.60001C6.61929 5.60001 5.5 6.71929 5.5 8.10001C5.5 9.48072 6.61929 10.6 8 10.6Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5513_107663)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19 9.285L7.07832 9.34371L7.09965 9.21936L7.0093 9.13129L7.13416 9.11314L7.19 9L7.24584 9.11314L7.3707 9.13129L7.28035 9.21936L7.30168 9.34371L7.19 9.285Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19 9.285L8.07832 9.34371L8.09965 9.21936L8.0093 9.13129L8.13416 9.11314L8.19 9L8.24584 9.11314L8.3707 9.13129L8.28035 9.21936L8.30168 9.34371L8.19 9.285Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19 9.88501L8.07832 9.94372L8.09965 9.81936L8.0093 9.73129L8.13416 9.71315L8.19 9.60001L8.24584 9.71315L8.3707 9.73129L8.28035 9.81936L8.30168 9.94372L8.19 9.88501Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69 7.785L7.57832 7.84371L7.59965 7.71936L7.5093 7.63129L7.63416 7.61314L7.69 7.5L7.74584 7.61314L7.8707 7.63129L7.78035 7.71936L7.80168 7.84371L7.69 7.785Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69 8.785L7.57832 8.84371L7.59965 8.71936L7.5093 8.63129L7.63416 8.61314L7.69 8.5L7.74584 8.61314L7.8707 8.63129L7.78035 8.71936L7.80168 8.84371L7.69 8.785Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99005 8.285L6.87837 8.34371L6.8997 8.21936L6.80935 8.13129L6.93421 8.11314L6.99005 8L7.04589 8.11314L7.17075 8.13129L7.0804 8.21936L7.10173 8.34371L6.99005 8.285Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28998 8.68499L6.1783 8.74371L6.19963 8.61935L6.10927 8.53128L6.23414 8.51314L6.28998 8.39999L6.34582 8.51314L6.47068 8.53128L6.38033 8.61935L6.40165 8.74371L6.28998 8.68499Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59002 6.985L8.47835 7.04371L8.49967 6.91935L8.40932 6.83128L8.53418 6.81314L8.59002 6.7L8.64586 6.81314L8.77072 6.83128L8.68037 6.91935L8.7017 7.04371L8.59002 6.985Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9624 7.49857L5.03759 6.5014C7.43656 6.6823 9.33001 7.47108 10.6941 8.87419L9.9771 9.57126C8.79481 8.35515 7.13119 7.66211 4.9624 7.49857Z",
    fill: "#F7FCFF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5513_107663",
    x: 1.90442,
    y: 3.85202,
    width: 12.1599,
    height: 8.23361,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.368627 0 0 0 0 0 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5513_107663"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5513_107663",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5513_107663",
    x1: 16,
    y1: 14,
    x2: 16,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE42"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrl);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "BRL.eb9857f81122173a2b4fd29dfd1149ea.svg";